import React, {Component} from 'react'

class FormRow extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            className: this.props.className || '',
            labelClassName: this.props.labelClassName || '',
            style: this.props.style || 'cols',
            name: this.props.name || '',
            label: this.props.label || '',
            input: this.props.input || '',
            help: this.props.help || '',

        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            className: nextProps.className || '',
            labelClassName: nextProps.labelClassName || '',
            name: nextProps.name || '',
            label: nextProps.label || '',
            input: nextProps.input || '',
            help: nextProps.help || '',
        })
    }

    render() {

        const colLabel = this.state.style === 'cols' ?  'col-2 text-right' : 'col-12'
        const colInput = this.state.style === 'cols' ?  'col-10' : 'col-12'

        return(
            <div className={"form-group row " + this.state.className}>
                <label className={colLabel + " col-form-label " + this.state.labelClassName} htmlFor={this.state.name}>
                    {this.state.label}
                </label>
                <div className={colInput}>
                    {this.state.input}

                    {this.state.help ? <small className="form-text text-muted m-0">
                        {this.state.help}
                    </small>: ''}
                </div>
            </div>
        )
    }
}

export default FormRow


// WEBPACK FOOTER //
// ./src/common/form/row.component.jsx